export let SupportedBrowsers;
(function (SupportedBrowsers) {
  SupportedBrowsers["Chrome"] = "Chrome";
  SupportedBrowsers["Safari"] = "Safari";
  SupportedBrowsers["Firefox"] = "Firefox";
})(SupportedBrowsers || (SupportedBrowsers = {}));